module.exports = __webpack_public_path__ + "static/media/vaers-data-dash.b2607c55.png";